import PropTypes from "prop-types";
import { ReduceStore } from "flux/utils";
import Dispatcher from "Dispatcher";
import LoadObject from "data/LoadObject";
import { hotLoadObject } from "data/storeUtils";
import DevelopmentActions from "data/dev/DevelopmentActions";
import DevDataManager from "data/dev/DevDataManager";

class ITManifestStore extends ReduceStore {

    constructor() {
        super(Dispatcher);
    }

    getInitialState() {
        return LoadObject.empty().withPropTypes({
            root: PropTypes.string.isRequired,
            // map of directory-name -> list-of-filename
            tests: PropTypes.objectOf(
                PropTypes.arrayOf(
                    PropTypes.string,
                ),
            ).isRequired,
        });
    }

    reduce(state, action) {
        switch (action.type) {
            case DevelopmentActions.START_IT_MANIFEST_LOAD:
                return state.loading(DevDataManager.loadITManifest());
            case DevelopmentActions.IT_MANIFEST_LOADED:
                return state.receiveValue({
                    root: action.data.root,
                    tests: action.data.tests
                        .split("\n")
                        .map(it => it.trim())
                        .filter(it => it.length > 0)
                        .reduce((dirs, path) => {
                                const parts = path.split("/");
                                const fn = parts.pop();
                                const dir = parts.join("/");
                                if (! dirs.hasOwnProperty(dir)) {
                                    dirs[dir] = [];
                                }
                                dirs[dir].push(fn);
                                return dirs; // tee-hee
                            }, {}),
                });
            case DevelopmentActions.IT_MANIFEST_ERROR:
                return state.receiveError(action.error);
            default:
                return state;
        }
    }

    getLoadObject() {
        return hotLoadObject(
            () => this.getState(),
            () => Dispatcher.dispatch({
                type: DevelopmentActions.START_IT_MANIFEST_LOAD,
            }),
        );
    }
}

export default new ITManifestStore();



// WEBPACK FOOTER //
// ./app/data/dev/ITManifestStore.js